import { useMediaQuery, useTheme } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useState } from 'react';
import FullScreenGallery from './FullScreenGallery';
import GalleryItem from './GalleryItem';

const Gallery = ({ className, items }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isFullScreen, setIsFullScreen] = useState(false);

  const previewItems = items.slice(0, isMobile ? 2 : 6);
  const diff = items.length - previewItems.length;
  const selectedItem = items[selectedIndex];

  function openFullScreen() {
    setIsFullScreen(true);
  }

  function closeFullScreen() {
    setIsFullScreen(false);
  }

  return (
    <>
      <div id="gallery" className={`${className} flex flex-col-reverse md:flex-row`}>
        <div className="flex md:flex-col">
          {previewItems.map((item, index) => (
            <GalleryItem
              key={item}
              className="m-1 thumbnail"
              border={selectedIndex === index ? 'active' : 'normal'}
              description={item}
              isPreview
              onClick={() => setSelectedIndex(index)}
              size="small"
              url={item}
            />
          ))}
          {diff > 0 && (
            <GalleryItem onClick={openFullScreen} className="m-1 thumbnail showMore">
              <div className="text-2xl">{`${diff}+`}</div>
            </GalleryItem>
          )}
        </div>
        <div className="flex-1 p-2">
          <GalleryItem
            className="preview"
            border="none"
            description={selectedItem}
            onClick={openFullScreen}
            size="full"
            url={selectedItem}
          />
        </div>
      </div>
      {isFullScreen && (
        <FullScreenGallery items={items} initialIndex={selectedIndex} onClose={closeFullScreen} />
      )}
    </>
  );
};

Gallery.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
};

Gallery.defaultProps = {
  className: '',
};

export default Gallery;
